import { useState, useEffect } from 'react'
import { NavBar, Card, Grid, Circle, Progress, Tag, Space, Loading, Empty } from 'react-vant'
import { ArrowLeft, ChartTrendingO, InfoO, FireO, MedalO, Success } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import request from '../../api/request'
import './style.css'

export default function AdminDataInsight() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [stats, setStats] = useState(null)

    const fetchData = async () => {
        setLoading(true)
        try {
            // 1. 先获取当前学年
            const yearRes = await request.get('/v2/academic-year/current/')
            const currentYear = yearRes.current_academic_year

            // 2. 带上学年请求统计数据，确保双端对齐
            const res = await request.get(`/v2/sports/tests/statistics/?academic_year=${currentYear}&include_progress=true`)
            if (res.success && res.data) {
                setStats({
                    ...res.data,
                    currentYearDisplay: currentYear // 保存用于显示
                })
            }
        } catch (error) {
            console.error('Failed to fetch statistics:', error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const formatYear = (yr) => {
        if (!yr) return '';
        if (typeof yr !== 'string') return `${yr}学年`;
        if (yr.includes('学年')) return yr;
        const match = yr.match(/^(\d{4}-\d{4})(.*)$/);
        if (match) {
            return `${match[1]}学年${match[2]}`;
        }
        return `${yr}学年`;
    };

    if (loading) return <div className="admin-dashboard theme-dark" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Loading vertical>量化数据中...</Loading></div>

    if (!stats) return <div className="admin-dashboard theme-dark"><NavBar title="体测数据简报" leftArrow={<ArrowLeft />} onClickLeft={() => navigate(-1)} /><Empty description="无法加载统计数据" /></div>

    const { summary, gradeProgress } = stats

    return (
        <div className="admin-dashboard theme-dark data-insight-page">
            <NavBar
                title="全校体测简报"
                leftArrow={<ArrowLeft />}
                onClickLeft={() => navigate(-1)}
                fixed
                placeholder
            />

            <div style={{ padding: '0 16px' }}>
                {/* 核心指标卡片 */}
                <Card className="glass-card" style={{ marginTop: 16, border: 'none' }}>
                    <Card.Body>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <MedalO color="var(--admin-accent)" size={20} />
                                <span style={{ fontSize: 16, fontWeight: 700 }}>核心达成率</span>
                            </div>
                            <Tag color="var(--admin-accent)" style={{ padding: '4px 10px', borderRadius: 4, fontWeight: 600 }}>
                                <span style={{ color: '#000' }}>{formatYear(stats.currentYearDisplay || '2025-2026')}</span>
                            </Tag>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Circle
                                    rate={Math.round((summary.excellentRate + summary.goodRate + summary.passRate) * 10) / 10}
                                    color="var(--admin-accent)"
                                    layerColor="rgba(255,255,255,0.05)"
                                    strokeWidth={60}
                                    size={80}
                                    text={<span style={{ color: '#fff', fontSize: 15 }}>{(summary.excellentRate + summary.goodRate + summary.passRate).toFixed(1)}%</span>}
                                />
                                <span style={{ fontSize: 12, color: 'var(--admin-text-sub)', marginTop: 8 }}>总体及格率</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Circle
                                    rate={summary.excellentRate}
                                    color="#FFD700"
                                    layerColor="rgba(255,255,255,0.05)"
                                    strokeWidth={60}
                                    size={80}
                                    text={<span style={{ color: '#fff', fontSize: 16 }}>{summary.excellentRate}%</span>}
                                />
                                <span style={{ fontSize: 12, color: 'var(--admin-text-sub)', marginTop: 8 }}>优秀率</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Circle
                                    rate={summary.excellentRate + summary.goodRate}
                                    color="#00b578"
                                    layerColor="rgba(255,255,255,0.05)"
                                    strokeWidth={60}
                                    size={80}
                                    text={<span style={{ color: '#fff', fontSize: 16 }}>{(summary.excellentRate + summary.goodRate).toFixed(1)}%</span>}
                                />
                                <span style={{ fontSize: 12, color: 'var(--admin-text-sub)', marginTop: 8 }}>优良率</span>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                {/* 状态总览 */}
                <div style={{ marginTop: 24, fontSize: 15, fontWeight: 600, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <FireO color="#d97706" size={18} /> 录入进度透视
                </div>

                <Grid columnNum={2} gutter={10} border={false} className="admin-grid">
                    <Grid.Item>
                        <div style={{ textAlign: 'left', width: '100%' }}>
                            <div style={{ color: 'var(--admin-text-sub)', fontSize: 12 }}>总覆盖人次</div>
                            <div style={{ fontSize: 22, fontWeight: 700, margin: '4px 0', color: 'var(--admin-accent)' }}>{summary.totalStudents}</div>
                            <Progress percentage={100} showPivot={false} strokeWidth={3} trackColor="rgba(255,255,255,0.05)" color="var(--admin-accent)" />
                        </div>
                    </Grid.Item>
                    <Grid.Item>
                        <div style={{ textAlign: 'left', width: '100%' }}>
                            <div style={{ color: 'var(--admin-text-sub)', fontSize: 12 }}>已入库统计</div>
                            <div style={{ fontSize: 22, fontWeight: 700, margin: '4px 0', color: '#00b578' }}>{summary.testedStudents}</div>
                            <Progress
                                percentage={Math.round((summary.testedStudents / summary.totalStudents) * 100)}
                                showPivot={false}
                                strokeWidth={3}
                                trackColor="rgba(255,255,255,0.05)"
                                color="#00b578"
                            />
                        </div>
                    </Grid.Item>
                </Grid>

                {/* 年级竞争力排名 */}
                <div style={{ marginTop: 24, fontSize: 15, fontWeight: 600, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <ChartTrendingO color="#e11d48" size={18} /> 年级推进看板 (录入进度)
                </div>

                <Card className="glass-card" style={{ border: 'none' }}>
                    <Card.Body>
                        <Space direction="vertical" block gap={20}>
                            {gradeProgress.map((gp, index) => (
                                <div key={index}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <span style={{
                                                width: 20, height: 20, borderRadius: 4, background: index < 3 ? 'var(--admin-accent)' : 'rgba(255,255,255,0.1)',
                                                display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 11, fontWeight: 'bold',
                                                color: index < 3 ? '#000' : '#fff'
                                            }}>
                                                {index + 1}
                                            </span>
                                            <span style={{ color: '#fff', fontWeight: 500, fontSize: 14 }}>{gp.grade}</span>
                                        </div>
                                        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>{gp.tested} / {gp.total} 人</span>
                                    </div>
                                    <Progress
                                        percentage={gp.percent}
                                        strokeWidth={8}
                                        trackColor="rgba(255,255,255,0.05)"
                                        color={gp.percent > 90 ? '#00b578' : (gp.percent > 60 ? 'var(--admin-accent)' : '#d97706')}
                                    />
                                </div>
                            ))}
                        </Space>
                    </Card.Body>
                </Card>

                <div style={{ textAlign: 'center', margin: '30px 0', padding: '0 40px', color: 'var(--admin-text-sub)', fontSize: 11, lineHeight: 1.6 }}>
                    <InfoO size={12} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                    数据简报基于当前学年实时汇总，及格率计算已排除“免考”及“缺考”异常状态。
                </div>
            </div>
        </div>
    )
}
